<template>
  <window :window-id="windowId">
    <template slot="tabs">
      <li class="nav-item" title="Clear">
        <a class="nav-link" href="#" @click.prevent="clear">
          <icon name="bolt"></icon>
        </a>
      </li>
      <li class="nav-item" title="Refresh">
        <a class="nav-link" href="#" @click.prevent="refresh">
          <icon name="refresh"></icon>
        </a>
      </li>
      <li class="nav-item" title="Open in new tab/window">
        <a class="nav-link" target="_blank" :href="src">
          <icon name="external-link"></icon>
        </a>
      </li>
    </template>
    <template>
      <window-tab :title="title" class="window-tab-pane-no-padding window-tab-pane-no-scrollbars">
        <div class="iframe-container">
          <iframe ref="iframe" :src="src + '&background=raster'" scrolling="no"></iframe>
        </div>
      </window-tab>
    </template>
  </window>
</template>

<script>
import { windowIdMixin } from '../mixins'
import * as action from '@/store/action-types'

export default {
  name: 'producer-window',
  mixins: [windowIdMixin],
  mounted () {
    window.setTimeout(this.adjustIframe.bind(this), 1000)
  },
  computed: {
    src () {
      let baseUrl = this.$env.WEBCG_PRODUCER
      // Add hostname if there is none
      const idx = baseUrl.indexOf('//:')
      if (idx >= 0) {
        baseUrl = baseUrl.slice(0, idx + 2) + window.location.hostname + baseUrl.slice(idx + 2)
      }
      return baseUrl + '/?channel=' + this.channelId + '&userId=' + this.accountId
    },
    title () {
      return this.$store.getters.windowTitle(this.windowId)
    },
    channelId () {
      return this.$store.getters.windowData(this.windowId).contentId
    },
    accountId () {
      const selectedAccount = this.$store.getters.selectedAccount
      return selectedAccount ? selectedAccount.accountId : ''
    },
    windowW () {
      return this.$store.getters.windowData(this.windowId).w
    },
    windowH () {
      return this.$store.getters.windowData(this.windowId).h
    }
  },
  watch: {
    windowW: function () {
      this.adjustIframe()
    },
    windowH: function () {
      this.adjustIframe()
    }
  },
  methods: {
    adjustIframe () {
      if (!this.$refs.iframe) {
        return
      }
      var container = this.$refs.iframe.parentElement
      var containerWidth = container.offsetWidth
      var containerHeight = container.offsetHeight

      // Calculate the aspect ratio
      var aspectRatio = 16 / 9

      // Calculate what the maximum size of the iframe should be
      var iframeWidth = containerWidth
      var iframeHeight = iframeWidth / aspectRatio

      // Check if calculated height is too high for the container
      if (iframeHeight > containerHeight) {
        iframeHeight = containerHeight
        iframeWidth = iframeHeight * aspectRatio
      }

      // Apply calculated dimensions to the iframe
      var iframe = container.querySelector('iframe')
      iframe.style.width = `${iframeWidth}px`
      iframe.style.height = `${iframeHeight}px`
    },
    clear () {
      this.$store.dispatch(action.CLEAR_CHANNEL, {channelId: this.channelId})
    },
    refresh () {
      const iframe = this.$refs.iframe
      // SecurityError: Permission denied to access property "reload" on cross-origin object
      // iframe.contentWindow.location.reload()
      iframe.src += ''
    }
  }
}
</script>

<style>
.iframe-container {
  position: relative;
  width: 100%; /* or fixed width */
  height: 100%; /* or fixed height */
  overflow: hidden;
  background-color: black;
}

iframe {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border: none;
  background-color: white;
}

.box-no-padding > .card-body {
  padding: 0;
  margin-bottom: -8px;
}
</style>



// WEBPACK FOOTER //
// src/components/producer-window.vue